export default {"src":"/uk/_next/static/media/myPensionsIconGrey.c49e3514.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};